<template>
  <navigation-link-component
    :class="$style.root"
    :data="item"
  />
</template>

<script setup>
const props = defineProps({
  item: {
    type: Object,
    required: true
  }
})
</script>

<style module>
.root {
  composes: font-size-large from global;
  padding-left: 1ch;
  text-indent: -1ch;
  display: inline-block;
}

.root[data-logo] {
  font-feature-settings: "dlig" 1;
}
</style>
